import styled from 'styled-components';

export const DataCourseExamMobile = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  width: 100%;

  > div {
    display: flex;
    flex-direction: row;
    align-items: start;
    width: 100%;
  }

  > div h1 {
    min-width: 90px;
    font-weight: 700;
    color: ${({ isDisabled }) => (isDisabled ? '#8090BB' : '#161D1F')};
  }

  > div span {
    flex: 1;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    font-weight: 400;
    color: ${({ isDisabled }) => (isDisabled ? '#8090BB' : '#161D1F')};
  }
`;
